import { useEffect, useState } from "react"
import { StyledTable } from "../Table.styled"
import { Table } from "../../../models/table";
import { CircularProgress, Typography } from "@mui/material";
import { useErrorBoundary } from "react-error-boundary";
import { handleApiErrors } from "../../../services/errorHandling";
import { useEditSystemTableMutation, useGetSystemTablesQuery } from "../../../redux/api/system-tables.api";

import SystemTableOptions from "./system-table-options/SystemTableOptions";
import ModelsOptions from "./models-options/ModelsOptions";




function SystemTables() {

  const { showBoundary } = useErrorBoundary();


  const { 
    data: systemTables, 
    isLoading: isFetchingSystemTables 
  } = useGetSystemTablesQuery();

  const [editSystemTable] = useEditSystemTableMutation();


  const [selectedTable, setSelectedTable] = useState<Table>();
  const [selectedManufacturer, setSelectedManufacturer] = useState<Table>();
  const [action, setAction] = useState<string>("browse");
  const [systemTablesCopy, setSystemTablesCopy] = useState<Table[]>();


  useEffect(()=>{

    if(systemTables){
      setSystemTablesCopy(systemTables);
    }
    
  },[systemTables]);



  /**
   * save the edited system table in the state
   * @param event 
   * @param tableChanged 
   */
  function apdateState(event: React.ChangeEvent<HTMLInputElement>, tableChanged: Table): void{

    const systemTablesToUpdate = systemTablesCopy?.map(
      table => table.id === tableChanged.id ? { ...tableChanged, name: event.target.value } : table
    );

    setSystemTablesCopy(systemTablesToUpdate);
  }


  /**
   * save the edited system table in db and store
   * @param table 
   */
  async function saveInput(tableChanged: Table): Promise<void>{
    
    try {
      await editSystemTable(tableChanged);
    } 
    
    catch (error) {
      handleApiErrors(error, showBoundary);
    }
  }


  /**
   * handling return back inside the component
   */
  function returnBack(): void {

    if (selectedManufacturer) {
      setSelectedManufacturer(undefined);
    }

    else if (selectedTable) {
      setSelectedTable(undefined);
    }
  }


  return (
    <StyledTable>

      { (isFetchingSystemTables) && <CircularProgress color="inherit" sx={{ display: "block", margin: "auto", padding: 4 }} />}

      { !isFetchingSystemTables && systemTablesCopy && !selectedTable && (
        <>
          <Typography variant="h3" className="title">
            טבלאות מערכת
          </Typography>
          <table>
            <tbody>
              {
                systemTablesCopy.map((table, index) => (
                  <tr key={index}>
                    <td>{table.index}.</td>
                    <td className="expand">
                      {action === 'edit' ?
                        <input value={table.name || ""} onChange={(e) => { apdateState(e, table) }} onBlur={() => { saveInput(table) }} /> :
                        <a className="clickable" onClick={() => { setSelectedTable(table) }}>{table.name}</a>
                      }
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
          <div className="buttons">
            {action === 'browse' ? <button onClick={() => { setAction('edit') }}>עריכה</button> : <button onClick={() => { setAction('browse') }}>סיום עריכה</button>}
          </div>
        </>
      )}

      {selectedTable && !selectedManufacturer && (
        <SystemTableOptions systemTable={selectedTable} returnBack={returnBack} getModelsTable={setSelectedManufacturer} />
      )}

      {selectedManufacturer && (
        <ModelsOptions manufacturerTable={selectedManufacturer} returnBack={returnBack} />
      )}
    </StyledTable>
  )
}

export default SystemTables